import React from 'react';
import Row from '../../../core/layout/Row';
import Column from '../../../core/layout/Column';
import TextInput from '../../../core/form/TextInput';
import PropTypes from 'prop-types';
import DateInput from '../../../core/form/DateInput';
import Card from '../../../core/layout/Card';
import Button from '../../../core/form/Button';
import { browserHistory } from 'react-router';
import { dollarCurrencyFormatter, realCurrencyFormatter } from '../../../core/consts';
import Divider from '../../../core/layout/Divider';
import BillProductsListContainer from './BillProductsListContainer';
import ContractSelectContainer from './BillContractSelectContainer';
import { get } from 'lodash';
import Separator from '../../../core/layout/Separator';
import PermissionValidator from '../../../core/layout/PermissionValidator';
import LocalFileInputButton from '../../../core/form/LocalFileInputButton';

const BillDetails = (props) => {
  return (
    <>
      <Card
        title="Bill Details"
        loading={props.loading}
        actions={
          <div style={{ display: 'flex', justifyContent: 'space-around' }}>
            <PermissionValidator allowedFor={['ADMIN', 'SUPPORT']}>
              {props.values.status === 'REVIEW' && (
                <div style={{ minWidth: 100, display: 'flex', justifyContent: 'space-around' }}>
                  <Button
                    icon="edit"
                    onClick={() =>
                      browserHistory.push({
                        pathname: `/billing/${props.values.id}`,
                        state: { from: { text: 'Billing', pathname: '/billing' } },
                      })
                    }
                  />
                  <Button icon="folder" tooltip="Reopen bill" onClick={() => props.onAction('open', props.values)} />
                  <Button
                    icon="gift"
                    tooltip="Set bill as no charge"
                    onClick={() => props.onAction('gift', props.values)}
                  />
                </div>
              )}
              {props.values.status === 'OPEN' && (
                <div style={{ minWidth: 110, display: 'flex', justifyContent: 'space-around' }}>
                  <Button
                    icon="edit"
                    onClick={() =>
                      browserHistory.push({
                        pathname: `/billing/${props.values.id}`,
                        state: { from: { text: 'Billing', pathname: '/billing' } },
                      })
                    }
                  />
                  <Button icon="mail" tooltip="Send to Client" onClick={() => props.onAction('send', props.values)} />
                  {!props.values.bankBillUrl && (
                    <LocalFileInputButton
                      loading={props.values.uploading}
                      accept="pdf"
                      onChange={(value) => props.onAction('upload', { ...props.values, bankBillFile: value })}
                    />
                  )}
                </div>
              )}
              {props.values.status === 'SENT_TO_CLIENT' && (
                <div style={{ minWidth: 75, display: 'flex', justifyContent: 'space-around' }}>
                  <Button icon="folder" tooltip="Reopen bill" onClick={() => props.onAction('open', props.values)} />
                  <Button
                    icon="credit-card"
                    tooltip="Set bill as payed"
                    onClick={() => props.onAction('pay', props.values)}
                  />
                </div>
              )}
            </PermissionValidator>
            {['SENT_TO_CLIENT', 'PAID'].includes(props.values.status) && props.values.billUrl && (
              <Button
                icon="file-pdf"
                tooltip="Download bill"
                onClick={() => props.onAction('download', props.values.billUrl)}
              />
            )}
            <span style={{ marginLeft: 10 }}>
              <Button
                icon="arrow-left"
                label="Back"
                type="default"
                onClick={() => browserHistory.replace('/billing')}
              />
            </span>
          </div>
        }
      >
        <Row>
          <Column size={1}>
            <TextInput disabled label="Bill Id" value={get(props.values, 'billId', '')} />
          </Column>
          <Column size={1.5}>
            <TextInput disabled label="Status" value={get(props.values, 'status', '')} />
          </Column>
          <Column size={2}>
            <DateInput disabled label="Due date" value={get(props.values, 'dueDate', null)} />
          </Column>
          <Column size={3}>
            <ContractSelectContainer disabled loading={props.loading} values={props.values} required />
          </Column>
          <Column size={4.5}>
            <TextInput disabled label="Social Reason" value={get(props.values, 'socialReason', '')} />
          </Column>
        </Row>
        <Row>
          <Column size={get(props.values, 'cancellationReason') ? 2 : 3}>
            <TextInput disabled label="Invoice id" value={get(props.values, 'paymentGatewayInvoiceId', '')} />
          </Column>
          <Column size={get(props.values, 'cancellationReason') ? 5 : 7}>
            <TextInput disabled label="Payment link" value={get(props.values, 'paymentGatewayInvoiceUrl', '')} />
          </Column>
          {get(props.values, 'cancellationReason') && props.values.status === 'CANCELED' && (
            <Column size={5}>
              <TextInput disabled label="Cancellation Reason" value={get(props.values, 'cancellationReason', '')} />
            </Column>
          )}
        </Row>
        <Divider title="Bill's Products" />
        <Row>
          <Column size={12}>
            <BillProductsListContainer readOnly />
            <div style={{ textAlign: 'right', fontSize: 18, fontWeight: 'bold' }}>
              <span>
                Total Price:{' '}
                {props.currencyType === 'real'
                  ? realCurrencyFormatter.format(props.total)
                  : dollarCurrencyFormatter.format(props.total)}
              </span>
            </div>
          </Column>
        </Row>
      </Card>
      <Separator />
      {props.values.billUrl && (
        <Card title="Bill" collapsible>
          <embed
            src={`${process.env.REACT_APP_FILES_URL}/${props.values.billUrl}`}
            type="application/pdf"
            width="100%"
            height="500px"
          />
        </Card>
      )}
    </>
  );
};

BillDetails.propTypes = {
  values: PropTypes.object,
  loading: PropTypes.bool,
  total: PropTypes.number,
  currencyType: PropTypes.oneOf(['real', 'dollar']),
  onAction: PropTypes.func.isRequired,
};

BillDetails.defaultProps = {
  values: {},
  loading: false,
  total: 0,
  currencyType: 'real',
};

export default BillDetails;
